import { useQuery } from '@tanstack/react-query';
import { get } from '../api/api';
import { API_URLS } from '../constants/apiUrl';

interface ITransactionRestrictions {
  matterId?: string;
  enabled?: boolean;
}
export const useFetchTransactionRestrictions = (params: ITransactionRestrictions) => {
  const urlWithId = `${API_URLS.TRANSACTION_RESTRICTIONS.replace(':id', params.matterId ?? '')}`;
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['transaction-restrictions', params],
    queryFn: () => {
      return get(urlWithId);
    },
    enabled: !!params.enabled,
  });

  return { data: error ? undefined : (data ?? null), isLoading, error, refetch };
};
